module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.4a5fd63a497aa321a8f2.js");
};